import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6564bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "youhuiquan-list-box" }
const _hoisted_2 = { class: "youhuiquan-list" }
const _hoisted_3 = {
  key: 0,
  class: "youhuiquan-title"
}
const _hoisted_4 = { class: "list-item" }
const _hoisted_5 = { class: "list-item-price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_7 = { class: "list-itme-list" }
const _hoisted_8 = { class: "list-itme-list-title" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponList.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (index==0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "可使用优惠券"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(item.amount), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, "满" + _toDisplayString(item.filter) + "齿轮币减" + _toDisplayString(item.amount) + "齿轮币", 1),
            _createElementVNode("p", null, "有效期: " + _toDisplayString(item.from) + "至" + _toDisplayString(item.to), 1)
          ]),
          _createElementVNode("span", {
            class: "list-item-button",
            onClick: ($event: any) => (_ctx.setCouponsIndex(index))
          }, "选择", 8, _hoisted_9)
        ])
      ]))
    }), 256))
  ]))
}